module.exports = __webpack_public_path__ + "static/media/404.5a60c59c.png";